import React from 'react';
import { Inbox } from 'lucide-react';

interface AlertProps {
    icon?: React.ReactNode;
    label?: string;
    subtitle?: string;
}

const Alert: React.FC<AlertProps> = ({
    icon = <Inbox />,
    label = "No data available",
    subtitle,
}) => {
    return (
        <div className="flex flex-col items-center justify-center text-center">
            <div className="bg-gray-200 rounded-full p-4 mb-4">
                <div className="text-gray-800">{icon}</div>
            </div>
            <p className="font-semibold text-gray-800">{label}</p>
            <p className="font-normal text-gray-500">{subtitle}</p>
        </div>
    );
};

export default Alert;
